<script lang="ts">
  import { tv } from 'tailwind-variants';

  import { BaseBtn, Icon, type BaseBtnProps, type IconName } from '@/ui/base';

  const styles = tv({
    base: 'rounded-sm p-3',
    variants: {
      selected: {
        false: 'bg-btn-tert ',
        true: 'bg-btn-tert-S',
      },
      disabled: {
        true: 'opacity-50',
        false: '',
      },
    },
    compoundVariants: [
      {
        disabled: false,
        selected: false,
        className: 'hocus:bg-btn-tert-H',
      },
    ],
  });
  let {
    icon,
    label,
    tooltip: tooltipProp = true,
    ...props
  }: Omit<BaseBtnProps, 'children' | 'tooltip'> & {
    icon: IconName;
    label: string;
    tooltip?: boolean | BaseBtnProps['tooltip'];
  } = $props();
  let cn = $derived(styles({ selected: props.selected, disabled: props.disabled ?? false }));
  let tooltip = $derived(
    tooltipProp === true ?
      ({
        label,
        anchor: 'right',
        size: 'big',
      } as const)
    : tooltipProp || undefined,
  );
</script>

<BaseBtn {...props} aria-label={label} {tooltip} class={cn}><Icon {icon} size={6} /></BaseBtn>
